import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_NAME = "WaveTech Solutions";
const SITE_URL = "https://wavetech.solutions";
const DEFAULT_DESCRIPTION = "WaveTech Solutions offers top-tier web development, SEO, and custom-coded solutions.";
const DEFAULT_IMAGE = "https://wavetech.solutions/wavetechoneletter.png";

const PAGE_METADATA = {
  "/": {
    title: "Shopify & Web Development Agency | WaveTech Solutions",
    description: "High-performance Shopify development, technical SEO, and web optimization for growing online businesses. Faster sites, higher conversions, better rankings.",
    type: "WebSite",
    richResults: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "WaveTech Solutions",
        "url": "https://wavetech.solutions",
        "logo": "https://wavetech.solutions/wavetechoneletter.png",
        "contactPoint": {
          "@type": "ContactPoint",
          "email": "daniel@wavetech.solutions",
          "contactType": "customer service"
        },
        "sameAs": [
          "https://www.linkedin.com/company/wavetech-solutions-99/",
          "https://www.youtube.com/@WavetechSolutions88"
        ]
      },
      // LocalBusiness schema - add phone number and coordinates if available
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "WaveTech Solutions",
        "image": "https://wavetech.solutions/wavetechoneletter.png",
        "@id": "https://wavetech.solutions",
        "url": "https://wavetech.solutions",
        "priceRange": "$$",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Los Angeles",
          "addressRegion": "CA",
          "postalCode": "90046",
          "addressCountry": "US"
        },
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "09:00",
          "closes": "17:00"
        }
      }
    ]
  },
  "/services": {
    title: "Shopify Development Services | Maintenance, SEO & Custom Solutions",
    description: "Expert Shopify development services including maintenance, technical SEO, performance optimization, and custom integrations for growing ecommerce stores.",
    type: "Service",
    richResults: [
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://wavetech.solutions/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Services",
            "item": "https://wavetech.solutions/services"
          }
        ]
      },
      {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "Shopify Development",
        "provider": {
          "@type": "Organization",
          "name": "WaveTech Solutions"
        },
        "areaServed": "Worldwide",
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Shopify Development Services",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Website Maintenance & Upgrade Plans"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Technical SEO & Performance Optimization"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Custom Web Development & Integrations"
              }
            }
          ]
        }
      }
    ]
  },
  "/contact": {
    title: "Contact Us | WaveTech Solutions",
    description: "Get in touch with WaveTech Solutions for Shopify development, SEO, and web optimization services. Fast response times and expert support.",
    type: "ContactPage",
    richResults: [
      {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "name": "Contact WaveTech Solutions",
        "url": "https://wavetech.solutions/contact",
        "email": "daniel@wavetech.solutions"
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "How do you structure pricing?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We offer fixed-rate or hourly models based on your project’s scope. Email us for a custom quote."
            }
          },
          {
            "@type": "Question",
            "name": "How long do website upgrades take?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Minor updates can be done in a day, while major overhauls can span weeks. We’ll give a timeline after assessing your needs."
            }
          },
          {
            "@type": "Question",
            "name": "Do you provide emergency support?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, for critical issues. Email daniel@wavetech.solutions with ‘URGENT’ in the subject line."
            }
          },
          {
            "@type": "Question",
            "name": "Can you integrate custom apps with Shopify?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Absolutely. We specialize in custom-coded solutions for Shopify."
            }
          }
        ]
      }
    ]
  },
  "/privacy": {
    title: "Privacy Policy | WaveTech Solutions",
    description: "Read our privacy policy to understand how we handle your data and ensure security.",
    type: "LegalService",
    richResults: [
      {
        "@context": "https://schema.org",
        "@type": "LegalService",
        "name": "WaveTech Privacy Policy",
        "url": "https://wavetech.solutions/privacy"
      }
    ]
  },
  "/wavenotify": {
  title: "Wave Notify - Shopify Restock Alerts & Back-in-Stock Notifications App",
  description: "Capture lost sales with automated back-in-stock notifications. Wave Notify sends email alerts when products return to inventory. Free plan available with 5 notifications/month. Starter $4.99/month, Pro $9.99/month, Elite $14.99/month.",
  type: "Product",
  richResults: [
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "Wave Notify",
      "applicationCategory": "BusinessApplication",
      "applicationSubCategory": "Ecommerce Application",
      "operatingSystem": "Web",
      "description": "Wave Notify is a Shopify app that helps merchants capture lost sales from out-of-stock products. Automatically displays 'Notify Me' forms on sold-out product pages and sends email notifications when inventory is restored. Creates Shopify customers, tags them, and builds segments for email marketing campaigns.",
      "featureList": [
        "Automatic restock notifications",
        "Email alerts when products return to inventory",
        "Customer account creation",
        "Shopify customer tags and segments",
        "Form customizer (Starter+ plans)",
        "Advanced analytics dashboard",
        "Shopify Email integration",
        "Theme app extension (app embed)",
        "Works with Dawn and other Shopify themes"
      ],
      "screenshot": "https://wavetech.solutions/WaveNotify.mp4",
      "downloadUrl": "https://apps.shopify.com/wave-notify",
      "author": {
        "@type": "Organization",
        "name": "WaveTech Solutions",
        "url": "https://wavetech.solutions"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://wavetech.solutions/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Wave Notify",
          "item": "https://wavetech.solutions/wavenotify"
        }
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://wavetech.solutions/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Wave Notify",
          "item": "https://wavetech.solutions/wavenotify"
        }
      ]
    }
  ]
},
  "/wavesync": {
  title: "Wave Sync - Shopify Product Syncing & Inventory Management App",
  description: "Keep products in sync automatically. Wave Sync syncs inventory, prices, and status between products in your Shopify store. Free plan available.",
  type: "Product",
  richResults: [
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "Wave Sync",
      "operatingSystem": "Web",
      "applicationCategory": "BusinessApplication",
      "description": "Wave Sync is a Shopify app that keeps products, inventory, and pricing in sync between linked products inside a single Shopify store.",
      "downloadUrl": "https://apps.shopify.com/wave-sync-1",
      "author": {
        "@type": "Organization",
        "name": "WaveTech Solutions",
        "url": "https://wavetech.solutions"
      }
    }
  ]
},
  "/blog": {
    title: "Blog | WaveTech Solutions",
    description: "Expert guides, tips, and insights for Shopify merchants. Learn about the best apps, inventory management, and ecommerce strategies.",
    type: "Blog",
    richResults: [
      {
        "@context": "https://schema.org",
        "@type": "Blog",
        "name": "WaveTech Solutions Blog",
        "url": "https://wavetech.solutions/blog"
      }
    ]
  },
  "/blog/best-shopify-apps": {
    title: "Best Shopify Apps for Ecommerce Success in 2025 | WaveTech Solutions",
    description: "Discover the best Shopify apps for inventory management, sales recovery, and ecommerce success. Learn about Wave Notify and Wave Sync.",
    type: "Article",
    richResults: [
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": "Best Shopify Apps for Ecommerce Success in 2025",
        "author": {
          "@type": "Organization",
          "name": "WaveTech Solutions"
        },
        "publisher": {
          "@type": "Organization",
          "name": "WaveTech Solutions",
          "logo": {
            "@type": "ImageObject",
            "url": "https://wavetech.solutions/wavetechoneletter.png"
          }
        }
      }
    ]
  },
  "/blog/best-inventory-apps": {
    title: "Best Shopify Inventory Management Apps in 2025 | WaveTech Solutions",
    description: "Complete guide to the best Shopify inventory management apps. Learn how Wave Sync can help you keep products in sync and manage inventory accurately.",
    type: "Article",
    richResults: [
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": "Best Shopify Inventory Management Apps in 2025",
        "author": {
          "@type": "Organization",
          "name": "WaveTech Solutions"
        },
        "publisher": {
          "@type": "Organization",
          "name": "WaveTech Solutions",
          "logo": {
            "@type": "ImageObject",
            "url": "https://wavetech.solutions/wavetechoneletter.png"
          }
        }
      }
    ]
  },
  "/blog/how-to-sync-products": {
    title: "How to Sync Products in Your Shopify Store: Complete Guide | WaveTech Solutions",
    description: "Learn how to sync products within your Shopify store with Wave Sync. Complete guide to product syncing, inventory management, and automation.",
    type: "Article",
    richResults: [
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": "How to Sync Products Between Shopify Stores: Complete Guide",
        "author": {
          "@type": "Organization",
          "name": "WaveTech Solutions"
        },
        "publisher": {
          "@type": "Organization",
          "name": "WaveTech Solutions",
          "logo": {
            "@type": "ImageObject",
            "url": "https://wavetech.solutions/wavetechoneletter.png"
          }
        }
      }
  ]
}
};

const SEO = () => {
  const location = useLocation();
  const path = location.pathname;
  const pageMetadata = PAGE_METADATA[path] || {
    title: SITE_NAME,
    description: DEFAULT_DESCRIPTION,
    type: "WebPage",
    richResults: []
  };

  // Helper function to set or update meta tag
  const setMetaTag = (property, content, isProperty = false) => {
    const selector = isProperty ? `meta[property="${property}"]` : `meta[name="${property}"]`;
    let metaTag = document.querySelector(selector);
    if (!metaTag) {
      metaTag = document.createElement('meta');
      if (isProperty) {
        metaTag.setAttribute('property', property);
      } else {
        metaTag.setAttribute('name', property);
      }
      document.head.appendChild(metaTag);
    }
    metaTag.setAttribute('content', content);
  };

  // Helper function to set or update link tag
  const setLinkTag = (rel, href) => {
    let linkTag = document.querySelector(`link[rel="${rel}"]`);
    if (!linkTag) {
      linkTag = document.createElement('link');
      linkTag.setAttribute('rel', rel);
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute('href', href);
  };

  useEffect(() => {
    const fullUrl = `${SITE_URL}${path === '/' ? '' : path}`;
    const pageImage = DEFAULT_IMAGE; // Can be customized per page later

    // Update title
    document.title = pageMetadata.title;

    // Update or create meta description
    setMetaTag('description', pageMetadata.description);

    // Canonical tag
    setLinkTag('canonical', fullUrl);

    // Open Graph tags (Facebook)
    setMetaTag('og:title', pageMetadata.title, true);
    setMetaTag('og:description', pageMetadata.description, true);
    setMetaTag('og:url', fullUrl, true);
    setMetaTag('og:type', pageMetadata.type === 'WebSite' ? 'website' : 'article', true);
    setMetaTag('og:image', pageImage, true);
    setMetaTag('og:image:width', '1200', true);
    setMetaTag('og:image:height', '630', true);
    setMetaTag('og:site_name', SITE_NAME, true);

    // Twitter Card tags
    setMetaTag('twitter:card', 'summary_large_image', true);
    setMetaTag('twitter:title', pageMetadata.title, true);
    setMetaTag('twitter:description', pageMetadata.description, true);
    setMetaTag('twitter:image', pageImage, true);

    // Remove existing JSON-LD
    const oldScripts = document.querySelectorAll('script[type="application/ld+json"]');
    oldScripts.forEach((script) => script.remove());

    // Inject structured data for rich results
    pageMetadata.richResults.forEach((data) => {
      const scriptTag = document.createElement("script");
      scriptTag.type = "application/ld+json";
      scriptTag.innerHTML = JSON.stringify(data);
      document.head.appendChild(scriptTag);
    });
  }, [path]);

  return null;
};

export default SEO;